module.exports = __webpack_public_path__ + "img/whats-new-0_en.77cf76e.jpg";